<template>
  <Breadcrumbs main="Administración" title="Eventos" />

  <div class="container-fluid">
    <div class="row project-cards">
      <topMenu :all-events="allEvents" @reloadList="loadEvents" />
    </div>
  </div>
</template>

<script>
import topMenu from "./projectlist/TopMenuAdmin.vue";
import connection from "@/includes/connection";

export default {
  name: "indexList",
  components: { topMenu },
  data() {
    return {
      allEvents: [],
    };
  },
  mounted() {
    this.loadEvents();
  },
  methods: {
    async loadEvents() {
      try {
        const response = await connection.get("/event/all/adm");
        this.allEvents = response.data || [];
      } catch (error) {
        console.error("Error cargando eventos:", error);
      }
    },
  },
};
</script>
